/**
 * Single switch for "is the 1YP Investment Scorecard reachable".
 *
 * The backend serves a scorecard only where `wt_api/oneyp/configs/<cc>.py` exists, so this list
 * is the frontend's half of that gate. Both the route guard and the entry-point card read it,
 * so the two can never disagree.
 */
export const ONE_YEAR_PLAN_COUNTRIES = ['BR', 'ZA', 'KR'] as const;

export type OneYearPlanCountry = (typeof ONE_YEAR_PLAN_COUNTRIES)[number];

export const isOneYearPlanAvailable = (selectedCountry?: string | null): boolean =>
  !!selectedCountry && (ONE_YEAR_PLAN_COUNTRIES as readonly string[]).includes(selectedCountry);
